import { call, put, takeEvery } from 'redux-saga/effects';
import { changeBikeModelVariants } from '../../requests/change_bike_variants_request';
import { changeBikeModelVariantRequestSuccess, changeBikeModelVariantRequestFailure } from '../actions/change_bike_model_variants.actions';
import { CHANGE_BIKE_MODEL_VARIANTS_REQUEST } from '../constants/bike_model_variants.constants';
import { message_success, message_error } from '../../../../../components/Message';

function* changeBikeModelVariantRequest({ variant_id, key, value }) {
    const changed_model_variant = yield call(changeBikeModelVariants, variant_id, key, value);
    const { result } = changed_model_variant;
    if (result) {
        yield put(changeBikeModelVariantRequestSuccess(key, changed_model_variant.options[key]));
        message_success('Bike model variant updated successfully!');
    } else {
        yield put(changeBikeModelVariantRequestFailure('Something gone wrong!'));
        message_error('Something gone wrong!');
    }
}

export default function* changeBikeModelVariantsSaga() {
    yield takeEvery(CHANGE_BIKE_MODEL_VARIANTS_REQUEST, changeBikeModelVariantRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_update/redux/sagas/change_bike_model_variants.saga.js